<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Nova Agenda</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioAgendaMedica" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-5 col-md-12 col-sm-12 col-12" formGroupName="pk">
                            <mat-label>Médico</mat-label>
                            <input matInput value="Médico" class="form-control" id="idMedico" required trim="blur"
                                name="idMedico" formControlName="idMedico" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioAgendaMedica.controls.pk.get('idMedico')?.hasError('required')">
                                O campo Médico é obrigatório.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-5 col-md-8 col-sm-12 col-12" formGroupName="pk">
                            <mat-label>Filial</mat-label>
                            <mat-select value="Filial" formControlName="idFilial" name="idFilial" id="idFilial"
                                required>
                                <mat-option *ngFor="let filial of listaFiliais" [value]="filial.id">
                                    {{filial.nome}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioAgendaMedica.controls.pk.get('idFilial')?.hasError('required')">
                                O campo Filial é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    
                        <mat-form-field class="form-group col-lg-2 col-md-4 col-sm-12 col-12">
                            <mat-label>Início Agenda</mat-label>
                            <input matInput [matDatepicker]="dataInicioAgendaDP" formControlName="dataInicioAgenda"
                                id="dataInicioAgenda" name="dataInicioAgenda">
                            <mat-datepicker-toggle matSuffix [for]="dataInicioAgendaDP"></mat-datepicker-toggle>
                            <mat-datepicker #dataInicioAgendaDP></mat-datepicker>

                            <mat-error
                                *ngIf="formularioAgendaMedica.controls.dataInicioAgenda.hasError('required')">
                                O campo Início Agenda é obrigatório.
                            </mat-error>

                            <mat-error
                                *ngIf="formularioAgendaMedica.controls.dataInicioAgenda.hasError('invalidDate')">
                                O campo Início Agenda está inválido.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-3 col-6" formGroupName="pk">
                            <mat-label>Dia</mat-label>
                            <mat-select value="Dia" formControlName="diaSemana" name="diaSemana" id="diaSemana">
                                <mat-option [value]=""></mat-option>
                                <mat-option *ngFor="let diaSemana of listaDiasDaSemana" [value]="diaSemana.codigo">
                                    {{diaSemana.descricao}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="formularioAgendaMedica.controls.pk.get('diaSemana')?.hasError('required')">
                                O campo Dia é obrigatório.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-3 col-6">
                            <mat-label>Hor. Inicial</mat-label>
                            <mat-select value="Hor. Inicial" formControlName="horaAtendimentoInicial"
                                name="horaAtendimentoInicial">
                                <mat-option *ngFor="let horaAtendimento of listaHorarios"
                                    [value]="horaAtendimento.codigo">
                                    {{ horaAtendimento.descricao }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="formularioAgendaMedica.controls.horaAtendimentoInicial.hasError('required')">
                                O campo Hor. Inicial é obrigatório.
                            </mat-error>
                            <mat-error
                                *ngIf="formularioAgendaMedica.controls.horaAtendimentoInicial.hasError('invalid')">
                                O campo Hor. Inicial está inválido.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-3 col-6">
                            <mat-label>Hor. Final</mat-label>
                            <mat-select value="Hor. Final" formControlName="horaAtendimentoFinal"
                                name="horaAtendimentoFinal">
                                <mat-option *ngFor="let horaAtendimento of listaHorarios"
                                    [value]="horaAtendimento.codigo">
                                    {{ horaAtendimento.descricao }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="formularioAgendaMedica.controls.horaAtendimentoFinal.hasError('required')">
                                O campo Hor. Final é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioAgendaMedica.controls.horaAtendimentoFinal.hasError('invalid')">
                                O campo Hor. Final está inválido.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-3 col-6">
                            <mat-label>Tempo Atd.</mat-label>
                            <input matInput type="number" value="Tempo Atd." class="form-control" id="tempoAtd"
                                trim="blur" name="tempoAtd" formControlName="tempoAtd" min="5" max="120" step="5">
                            <mat-error *ngIf="formularioAgendaMedica.controls.tempoAtd.hasError('required')">
                                O campo Tempo Atd. é obrigatório.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-6">
                            <mat-label>Idade Min.</mat-label>
                            <input matInput type="number" value="Idade Min." class="form-control" id="atdIdadeMinima"
                                trim="blur" name="atdIdadeMinima" formControlName="atdIdadeMinima" min="0" max="125">
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-6">
                            <mat-label>Idade Max.</mat-label>
                            <input matInput type="number" value="Idade Max." class="form-control" id="atdIdadeMaxima"
                                trim="blur" name="atdIdadeMaxima" formControlName="atdIdadeMaxima" min="0" max="125">
                        </mat-form-field>

                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-4 col-md-4 col-sm-4 col-12"
                            style="padding-top: 2px;">
                            <input matInput style="display: none">
                            <mat-checkbox id="atdPortadorNecessidade" formControlName="atdPortadorNecessidade">Atd. PNE?
                            </mat-checkbox>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Sub-Especialidades</mat-label>
                            <mat-select formControlName="procedimentos" name="procedimentos" id="procedimentos" multiple
                                class="custom-multiple-select">
                                <!-- <mat-select-trigger>
                                    {{(controlProcedimentos.value && controlProcedimentos.value[0]) ?
                                    controlProcedimentos.value[0].nome : ''}}
                                    <span *ngIf="controlProcedimentos.value?.length > 1"
                                        class="example-additional-selection">
                                        (+{{controlProcedimentos.value.length - 1}}
                                        {{controlProcedimentos.value?.length === 2 ? 'outro' :
                                        'outros'}})
                                    </span>
                                </mat-select-trigger> -->
                                <mat-option *ngFor="let procedimentoConsulta of listaDeProcedimentoConsulta"
                                    [value]="procedimentoConsulta">
                                    {{procedimentoConsulta.nome}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioAgendaMedica.controls.procedimentos.hasError('required')">
                                Selecione pelo menos uma Consulta.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Planos de Saúde</mat-label>
                            <mat-select formControlName="planosDeSaude" name="planosDeSaude" id="planosDeSaude" multiple
                                class="custom-multiple-select">
                                <!-- <mat-select-trigger>
                                    {{(controlPlanosDeSaude.value && controlPlanosDeSaude.value[0]) ?
                                    controlPlanosDeSaude.value[0].nome : ''}}
                                    <span *ngIf="controlPlanosDeSaude.value?.length > 1"
                                        class="example-additional-selection">
                                        (+{{controlPlanosDeSaude.value.length - 1}}
                                        {{controlPlanosDeSaude.value?.length === 2 ? 'outro' :
                                        'outros'}})
                                    </span>
                                </mat-select-trigger> -->
                                <mat-option *ngFor="let planoDeSaude of listaDePlanosDeSaude" [value]="planoDeSaude">
                                    {{planoDeSaude.nome}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioAgendaMedica.controls.planosDeSaude.hasError('required')">
                                Selecione pelo menos um Plano de Saúde.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioAgendaMedica.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="gotoList()" matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>